import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class DropdownService {
	constructor(private apiService: ApiService) { }
	getLanguages() {
		const URL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/languages/v1`;
		return this.apiService.get(URL);
	}
	getReligions() {
		const URL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/religions/v1`;
		return this.apiService.get(URL);
	}
	getCategory() {
		const URL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/categories/v1`;
		return this.apiService.get(URL);
	}
	getDisabilityTypes() {
		const URL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/disability/v`;
		return this.apiService.get(URL);
	}
	getEducationalQualifications() {
		const URL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/educationalqualifications/v1`;
		return this.apiService.get(URL);
	}
	getAssociatedPrgNames() {
		const URL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/associatedprogram`;
		return this.apiService.get(URL);
	}
	getLanguagesForPmkvyBatch() {
		const URL = `${environment.userServiceUrl}/api/user/v1/get/dropdown/data`;
		return this.apiService.get(URL);
	}

	getHeardAboutUs() {
		const URL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/heardaboutus`;
		return this.apiService.get(URL)
	}
}
